module.exports = __webpack_public_path__ + "img/personas.90e48b66.png";